import { controlToastState } from "risa-oasis-ui_v2";
import {
  getCmmInputDataForOrder,
  reRunWorkflows,
} from "../../../api/bigQuery/nycbsPharmaOrders";
import { OrganizationType } from "../../../enums/organizationTypes";

export const executeRerunFromOncoEmr = async (
  orderId: string,
  onSuccess?: () => void,
  orgIdOverride?: string,
) => {
  try {
    const orderResponse = await getCmmInputDataForOrder(orderId);
    const orderData = orderResponse?.["details"];

    if (!orderData) {
      throw new Error("Failed to fetch order data");
    }

    const orgId = orgIdOverride || orderData?.org_id;

    let payloadBasedOnType = {};

    if (orderData?.type === "Internal") {
      payloadBasedOnType = {
        type: "Internal",
        prescriber_name: orderData?.provider_first_name
          ? `${orderData.provider_first_name} ${orderData.provider_last_name || ""}`.trim()
          : "",
        sftp_rx_bin: orderData?.sftp_rx_bin,
        sftp_member_id: orderData?.sftp_member_id,
      };
    } else if (orderData?.type === "External") {
      payloadBasedOnType = {
        type: "External",
        prescriber_name: orderData?.provider_first_name
          ? `${orderData.provider_first_name} ${orderData.provider_last_name || ""}`.trim()
          : "",
      };
    }

    const drugName =
      orderData?.drug_name_onco_emr || orderData?.drug_name;

    let basePayload = {};

    if (orgId === OrganizationType.NYCBS_PHARMA) {
      basePayload = {
        drug_name: drugName,
        identifier: orderData?.identifier,
        patient_mrn: orderData?.patient_mrn,
        org_id: orgId,
        is_new_request: true,
        ...payloadBasedOnType,
      };
    } else if (orgId === OrganizationType.ASTERA) {
      basePayload = {
        drug_name: drugName,
        identifier: orderData?.identifier,
        patient_dob: orderData?.patient_dob,
        patient_last_name: orderData?.patient_last_name,
        external_source_identifier: orderData?.external_source_identifier,
        org_id: orgId,
        is_new_request: true,
        ...payloadBasedOnType,
      };
    } else {
      basePayload = {
        drug_name: drugName,
        identifier: orderData?.identifier,
        patient_mrn: orderData?.patient_mrn,
        org_id: orgId,
        is_new_request: true,
        ...payloadBasedOnType,
      };
    }

    await reRunWorkflows(basePayload);

    controlToastState("re-run-success-onco-emr");

    if (onSuccess) {
      onSuccess();
    }
  } catch (error) {
    console.error("Error rerunning from Onco EMR:", error);
    controlToastState("re-run-error");
  }
};
